import type { RJSFSchema, UiSchema } from "@rjsf/utils";
import { baseJsonSchema, baseUiSchema } from "@/views/cms/EditorView/mediaSchemas/baseMediaSchema";

const tempJson = JSON.parse(JSON.stringify(baseJsonSchema)) as RJSFSchema;
delete tempJson?.properties?.credits;
export const DMJsonSchema: RJSFSchema = tempJson;

const tempUi = JSON.parse(JSON.stringify(baseUiSchema)) as UiSchema;
delete tempUi.credits;

tempUi.general.alt_text = {
  ...tempUi.general.alt_text,
  "ui:showAiButton": true,
  "ui:aiFunctionType": "altText",
};

export const DMUiSchema: UiSchema = tempUi;
